// extracted by mini-css-extract-plugin
module.exports = {"container":"_6410344d","tooltipTrigger":"_7fb03447","title":"_9f47dcaa","icon":"_dda0c01","goldDiamond":"_897d10ce","platinumDiamond":"_4cadd418"};